var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArbolLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 23,
    viewBox: "0 0 89 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4603 7.35665H7.08948C6.65715 7.35665 6.40446 6.86924 6.65364 6.51593L10.7093 0.765379C10.9179 0.469531 11.3544 0.463091 11.5717 0.752655L15.8869 6.50321C16.1507 6.85478 15.8999 7.35665 15.4603 7.35665Z",
    fill: "url(#paint0_linear_297_14824)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2398 6.05832L20.7732 4.46065C21.0126 4.30967 20.9799 3.9535 20.717 3.84787L14.4786 1.34208C14.1359 1.20443 13.841 1.62052 14.0877 1.89368L17.7927 5.99715C17.9066 6.1233 18.0958 6.14918 18.2398 6.05832Z",
    fill: "url(#paint1_linear_297_14824)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7672 12.2973L18.9196 7.76295C18.8566 7.60818 18.9139 7.43083 19.0559 7.34126L21.5553 5.76503C21.8018 5.60958 22.1203 5.80537 22.0895 6.09346L21.4377 12.2041C21.3995 12.5624 20.9034 12.6314 20.7672 12.2973Z",
    fill: "url(#paint2_linear_297_14824)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4392 19.1364V22.1139C10.4392 22.3952 10.1186 22.559 9.88763 22.3956L4.40818 18.5192C4.10719 18.3063 4.30299 17.8363 4.66775 17.8961L10.1472 18.795C10.3156 18.8226 10.4392 18.9671 10.4392 19.1364Z",
    fill: "url(#paint3_linear_297_14824)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2543 18.7906L17.1037 17.9038C17.4611 17.8384 17.6686 18.2907 17.3842 18.515L12.5347 22.3393C12.3061 22.5196 11.9686 22.3581 11.9686 22.0684V19.1309C11.9686 18.964 12.0888 18.8209 12.2543 18.7906Z",
    fill: "url(#paint4_linear_297_14824)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31839 4.49385L3.85177 6.09152C3.99585 6.18237 4.18505 6.15649 4.29895 6.03035L8.00392 1.92688C8.25056 1.65372 7.95567 1.23763 7.61299 1.37527L1.37464 3.88107C1.11168 3.9867 1.07899 4.34287 1.31839 4.49385Z",
    fill: "url(#paint5_linear_297_14824)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17197 7.79614L1.32437 12.3305C1.18823 12.6646 0.692084 12.5956 0.653859 12.2373L0.00206558 6.12666C-0.0286642 5.83856 0.289803 5.64278 0.536292 5.79823L3.03569 7.37446C3.17771 7.46403 3.23503 7.64138 3.17197 7.79614Z",
    fill: "url(#paint6_linear_297_14824)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86629 8.89684H14.3257C14.7407 8.89684 14.9967 9.34997 14.7825 9.70543L11.5842 15.0132C11.3779 15.3556 10.8822 15.3577 10.6729 15.0172L7.41187 9.70936C7.19355 9.35401 7.44923 8.89684 7.86629 8.89684Z",
    fill: "url(#paint7_linear_297_14824)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56127 9.70614L1.59437 15.1063C1.41765 15.428 1.61106 15.8279 1.97293 15.889L8.92759 17.0644C9.37785 17.1404 9.70928 16.6524 9.47249 16.2619L5.48472 9.68639C5.27187 9.33541 4.75892 9.34638 4.56127 9.70614Z",
    fill: "url(#paint8_linear_297_14824)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8172 16.2617L16.688 9.72208C16.901 9.3622 17.4265 9.37633 17.6198 9.74714L20.4204 15.1178C20.5872 15.4377 20.3949 15.8275 20.0396 15.8897L13.3682 17.0587C12.9195 17.1373 12.5852 16.6536 12.8172 16.2617Z",
    fill: "url(#paint9_linear_297_14824)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9098 19.8778L40.6763 3.47369H37.3251L31.0916 19.8778H34.7473L36.0362 16.2924H41.9652L43.2541 19.8778H46.9098ZM39.0124 8.01998L40.9106 13.3396H37.0908L39.0124 8.01998Z",
    fill: "#0D1329"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7814 8.06685H54.4457C53.0162 8.06685 52.1257 8.55897 51.4929 10.0353V8.06685H48.2121V19.8778H51.4929V14.1364C51.4929 12.121 52.2194 10.7852 53.8364 10.7852H55.7814V8.06685Z",
    fill: "#0D1329"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9764 20.0653C67.4681 20.0653 69.5538 17.6516 69.5538 13.9723C69.5538 10.2931 67.4681 7.87937 64.0232 7.87937C62.5469 7.87937 61.3986 8.4418 60.7424 9.30887V2.93469H57.485V19.8778H60.7424V18.5889C61.3986 19.5029 62.6172 20.0653 63.9764 20.0653ZM63.4608 17.2532C61.7032 17.2532 60.5549 15.9408 60.5549 13.9723C60.5549 11.9804 61.7032 10.6681 63.4608 10.6681C65.1715 10.6681 66.3433 11.9804 66.3433 13.9723C66.3433 15.9408 65.1715 17.2532 63.4608 17.2532Z",
    fill: "#0D1329"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9505 20.0653C80.5828 20.0653 83.184 17.4875 83.184 13.9723C83.184 10.4572 80.5828 7.87937 76.9505 7.87937C73.3181 7.87937 70.7169 10.4572 70.7169 13.9723C70.7169 17.4875 73.3181 20.0653 76.9505 20.0653ZM76.9505 17.2532C75.1929 17.2532 73.9977 15.9174 73.9977 13.9723C73.9977 12.0038 75.1929 10.6681 76.9505 10.6681C78.7081 10.6681 79.9032 12.0038 79.9032 13.9723C79.9032 15.9174 78.7081 17.2532 76.9505 17.2532Z",
    fill: "#0D1329"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4107 19.8778V2.93469H85.1533V19.8778H88.4107Z",
    fill: "#0D1329"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_297_14824",
    x1: 11.0805,
    y1: 0.529749,
    x2: 10.397,
    y2: 25.0173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170206,
    stopColor: "#6AB96A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834381,
    stopColor: "#1E253F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_297_14824",
    x1: 11.0805,
    y1: 0.529749,
    x2: 10.397,
    y2: 25.0173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170206,
    stopColor: "#6AB96A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834381,
    stopColor: "#1E253F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_297_14824",
    x1: 11.0805,
    y1: 0.529749,
    x2: 10.397,
    y2: 25.0173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170206,
    stopColor: "#6AB96A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834381,
    stopColor: "#1E253F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_297_14824",
    x1: 11.0805,
    y1: 0.529749,
    x2: 10.397,
    y2: 25.0173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170206,
    stopColor: "#6AB96A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834381,
    stopColor: "#1E253F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_297_14824",
    x1: 11.0805,
    y1: 0.529749,
    x2: 10.397,
    y2: 25.0173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170206,
    stopColor: "#6AB96A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834381,
    stopColor: "#1E253F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_297_14824",
    x1: 11.0805,
    y1: 0.529749,
    x2: 10.397,
    y2: 25.0173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170206,
    stopColor: "#6AB96A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834381,
    stopColor: "#1E253F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_297_14824",
    x1: 11.0805,
    y1: 0.529749,
    x2: 10.397,
    y2: 25.0173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170206,
    stopColor: "#6AB96A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834381,
    stopColor: "#1E253F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_297_14824",
    x1: 11.0805,
    y1: 0.529749,
    x2: 10.397,
    y2: 25.0173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170206,
    stopColor: "#6AB96A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834381,
    stopColor: "#1E253F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_297_14824",
    x1: 11.0805,
    y1: 0.529749,
    x2: 10.397,
    y2: 25.0173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170206,
    stopColor: "#6AB96A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834381,
    stopColor: "#1E253F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_297_14824",
    x1: 11.0805,
    y1: 0.529749,
    x2: 10.397,
    y2: 25.0173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170206,
    stopColor: "#6AB96A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834381,
    stopColor: "#1E253F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbolLogo);
export default __webpack_public_path__ + "static/media/arbol-logo.71613b2d.svg";
export { ForwardRef as ReactComponent };